<template>
  <div class="content-page" @click="hideTagsVisible">
    <div class="bd" v-if="!isShowSort">
      <div class="tab-header">
        <div class="header-left">
          <div class="btn-group-one">
            <el-button
              type="primary"
              size="small"
              @click="linkTo('/service/edit')"
              v-if="shopIsMaster"
              >添加服务</el-button
            >
            <el-button
              type="primary"
              :disabled="menuSel == 'hot'"
              plain
              size="small"
              @click="goodsShort"
              v-if="shopIsMaster"
              >排序</el-button
            >
            <!-- <el-button type="primary" size="small" @click="exportGoods"
              >导出服务</el-button
            >
            <el-upload
              class="upload-xls"
              action="/edcmanageapi/Goods_importGoodsNum"
              :http-request="uploadXls"
              :show-file-list="false"
              v-if="shopIsMaster"
            >
              <el-button type="primary" size="small">上传服务</el-button>
            </el-upload>
            <el-link
              type="primary"
              class="fix-middle"
              :underline="false"
              :href="xlsLink"
              v-if="shopIsMaster"
            >
              <i class="iconfont iconxiazai-copy"></i>下载模板
            </el-link> -->
          </div>
          <div class="btn-group-two">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="allChecked"
              label="全选"
              border
              @change="checkAllChange"
              size="small"
              :disabled="totalPage <= 0"
            ></el-checkbox>
            <el-button
              plain
              :disabled="isSel ? false : true"
              size="small"
              v-if="shopIsMaster"
              @click="toggleSaleStatusAll(0)"
              >上架</el-button
            >
            <el-button
              plain
              :disabled="isSel ? false : true"
              size="small"
              v-if="shopIsMaster"
              @click="toggleSaleStatusAll(1)"
              >下架</el-button
            >
            <el-button
              plain
              :disabled="isSel ? false : true"
              size="small"
              @click.stop="tagsVisible = true"
              v-popover:tagsType
              v-if="shopIsMaster"
              >改分组</el-button
            >
            <el-button
              plain
              :disabled="isSel ? false : true"
              size="small"
              @click="delGoodsAll"
              v-if="shopIsMaster"
              >删除</el-button
            >
            <el-popover
              ref="tagsType"
              placement="bottom-start"
              width="100"
              trigger="manual"
              popper-class="tags-type"
              v-model="tagsVisible"
            >
              <div class="changeTags">
                <el-radio-group v-model="tagsChange">
                  <el-radio
                    v-for="item in changeMenuList"
                    :key="item.goodsCategoryId"
                    :label="item.goodsCategoryId"
                    >{{ item.categoryName }}</el-radio
                  >
                </el-radio-group>
                <el-button type="primary" size="mini" @click="changeCategoryAll"
                  >保存</el-button
                >
                <el-button type="info" size="mini" @click="tagsVisible = false"
                  >取消</el-button
                >
              </div>
            </el-popover>
          </div>
        </div>
        <div class="header-right">
          <el-select v-model="statusValue" placeholder="请选择" size="small">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            placeholder="请输入服务..."
            v-model.trim="searchInput"
            class="input-search"
            size="small"
            @keyup.enter.native="searchGoods"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchGoods"
            ></el-button>
          </el-input>
        </div>
      </div>
      <div class="tab-content">
        <ol class="goods-classify-list" v-if="!isShowSearch">
          <li
            v-for="item in menuList"
            :key="item.goodsCategoryId"
            :class="menuSel == item.goodsCategoryId ? 'active' : ''"
            @click="menuSelAction(item.goodsCategoryId)"
          >
            {{ item.categoryName }}
          </li>
        </ol>
        <div
          class="goods-list"
          v-loading="isLoad"
          :class="{ screen: isShowSearch }"
        >
          <div class="search-header" v-if="isShowSearch">
            {{ totalPage }}个搜索结果
            <el-link type="primary" :underline="false" @click="resetSearch"
              >返回</el-link
            >
          </div>
          <div v-if="goodsList.length">
            <el-checkbox-group
              v-model="checkedGoodsList"
              @change="checkedGoodsChange"
            >
              <el-table
                :data="goodsList"
                style="width: 100%;"
                :show-header="false"
              >
                <el-table-column>
                  <template slot-scope="scope">
                    <el-checkbox :label="scope.row.goodsId">
                      <div class="goods-info">
                        <el-image
                          class="pic"
                          :src="scope.row.goodsImage || defaultImg"
                          fit="fill"
                          :class="{
                            'lower-shelf': !scope.row.saleStatus,
                          }"
                        ></el-image>
                        <div class="info">
                          <div class="title">
                            {{ scope.row.goodsName }}
                            <div class="tag-list">
                              <span v-if="scope.row.unitType == 2">计重</span>
                            </div>
                          </div>
                          <p class="price">￥{{ scope.row.retailPrice }}</p>
                        </div>
                      </div>
                    </el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    {{ scope.row.serviceTime }}分钟
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="scope">
                    销量：{{ scope.row.monthlySales || 0 }}
                  </template>
                </el-table-column>
                <el-table-column width="380" header-align="right">
                  <template slot-scope="scope">
                    <div class="table-action">
                      <el-button
                        size="small"
                        type="primary"
                        plain
                        @click="goodsDetail(scope.row.goodsId)"
                        >查看详情</el-button
                      >
                      <el-button
                        size="small"
                        type="primary"
                        plain
                        v-if="shopIsMaster"
                        @click="editGoods(scope.row.goodsId)"
                        >编辑</el-button
                      >
                      <el-button
                        size="small"
                        type="primary"
                        :plain="scope.row.saleStatus ? true : false"
                        v-if="
                          (isMaster && shopIsMaster) ||
                            (!isMaster && !shopIsMaster)
                        "
                        @click="
                          toggleSaleStatus(
                            scope.row.saleStatus,
                            scope.row.goodsId
                          )
                        "
                        >{{ scope.row.saleStatus ? "下架" : "上架" }}</el-button
                      >
                      <el-popover
                        placement="bottom-start"
                        width="100"
                        trigger="manual"
                        popper-class="tags-type"
                        v-model="scope.row.visible"
                        v-if="shopIsMaster"
                      >
                        <div class="changeTags">
                          <el-radio-group v-model="scope.row.tagsChange">
                            <el-radio
                              v-for="item in changeMenuList"
                              :key="item.goodsCategoryId"
                              :label="item.goodsCategoryId"
                              >{{ item.categoryName }}</el-radio
                            >
                          </el-radio-group>
                          <div class="nowrap">
                            <el-button
                              type="primary"
                              size="mini"
                              @click="
                                changeCategory(
                                  scope.row.goodsId,
                                  scope.row.tagsChange,
                                  scope.$index
                                )
                              "
                              >保存</el-button
                            >
                            <el-button
                              type="info"
                              size="mini"
                              @click.stop="hideTagsVisible"
                              >取消</el-button
                            >
                          </div>
                        </div>
                        <el-button
                          size="small"
                          slot="reference"
                          plain
                          @click.stop="showTagsVisible(scope.$index)"
                          >改分组</el-button
                        >
                      </el-popover>
                      <el-button
                        size="small"
                        plain
                        @click="delGoods(scope.row.goodsId)"
                        v-if="shopIsMaster"
                        >删除</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-checkbox-group>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-size="pageSize"
              :current-page="pageNo"
              background
              layout="prev, pager, next, jumper"
              :total="totalPage"
            ></el-pagination>
          </div>
          <div v-if="!goodsList.length && !isShowSearch">
            <div class="list-none">
              <img src="@/assets/img/common/list-none.png" alt />
              <p>暂无更多服务</p>
              <el-button
                type="primary"
                size="small"
                @click="linkTo(`/service/edit?goodsCategoryId=${menuSel}`)"
                v-if="shopIsMaster"
                >新建服务</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bd sort" v-show="isShowSort">
      <div class="tab-header">
        <el-button type="primary" size="small" @click="saveSort"
          >保存排序</el-button
        >
        <el-button type="primary" plain size="small" @click="cancelSort"
          >取消</el-button
        >
        <span class="sort-tips">鼠标拖拽进行排序</span>
      </div>
      <div class="tab-content">
        <div class="goods-list">
          <div v-if="goodsList.length">
            <div
              class="goods-item"
              v-for="(item, index) in goodsList"
              :key="item.goodsId"
              v-dragging="{ item: item, list: goodsList }"
            >
              <div class="goods-info">
                <el-image
                  class="pic"
                  :src="item.goodsImage || defaultImg"
                  fit="fill"
                  :class="{
                    'lower-shelf': !item.saleStatus,
                  }"
                ></el-image>
                <div class="info">
                  <p class="title">{{ item.goodsName }}</p>
                  <p class="price">￥{{ item.retailPrice }}</p>
                </div>
              </div>
              <div class="action">
                <el-button
                  size="small"
                  type="primary"
                  plain
                  @click="moveToTop(index)"
                  >移到顶部</el-button
                >
                <el-button
                  size="small"
                  type="primary"
                  plain
                  @click="moveToBottom(index)"
                  >移到底部</el-button
                >
              </div>
            </div>
          </div>
          <div v-else>
            <div class="list-none">
              <img src="@/assets/img/common/list-none.png" alt />
              <p>暂无更多服务</p>
              <el-button
                type="primary"
                size="small"
                @click="linkTo(`/service/edit?goodsCategoryId=${menuSel}`)"
                v-if="shopIsMaster"
                >新建服务</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="dialog-selgoods"
      title="选择服务"
      :visible.sync="dialogGoodsSel"
    >
      <div class="content-page">
        <div class="bd">
          <div class="tab-header">
            <div class="header-right">
              <el-input
                placeholder="请输入服务..."
                v-model.trim="goodsLibrarySearchInput"
                class="input-search"
                size="small"
                @keyup.enter.native="goodsLibrarySearchGoods"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="goodsLibrarySearchGoods"
                ></el-button>
              </el-input>
            </div>
          </div>
          <div class="tab-content">
            <ol class="goods-classify-list">
              <li
                v-for="item in goodsLibraryClassifyOptions"
                :key="item.goodsCategoryId"
                :class="
                  goodsLibraryMenuSel == item.categoryName ? 'active' : ''
                "
                @click="goodsLibraryMenuSelAction(item.categoryName)"
              >
                {{ item.categoryName }}
              </li>
            </ol>
            <div class="goods-list" v-loading="isLoad">
              <div class="list-title">
                <div class="title">服务</div>
                <div class="title">图片</div>
              </div>
              <el-checkbox-group
                v-model="goodsLibraryCheckedGoodsList"
                @change="goodsLibraryCheckedGoodsChange"
              >
                <el-table
                  :data="goodsLibraryGoodsList"
                  style="width: 100%;"
                  :show-header="false"
                >
                  <el-table-column width="400">
                    <template slot-scope="scope">
                      <el-checkbox :label="scope.row.id">
                        <div class="goods-info">
                          <el-image
                            class="pic"
                            :src="scope.row.goodsImage || defaultImg"
                            fit="fill"
                          ></el-image>
                          <div class="info">
                            <div class="title">
                              {{ scope.row.goodsName }}
                              <div class="tag-list">
                                <span v-if="scope.row.unitType == 2">计重</span>
                              </div>
                            </div>
                            <!-- <p class="price">￥{{ scope.row.retailPrice }}</p> -->
                          </div>
                        </div>
                      </el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="previewImg = scope.row.goodsImage"
                        >查看</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-checkbox-group>
              <div class="list-footer">
                <el-checkbox
                  :indeterminate="goodsLibraryIsIndeterminate"
                  v-model="goodsLibraryAllChecked"
                  label="全选"
                  border
                  @change="goodsLibraryCheckAllChange"
                  size="small"
                  :disabled="goodsLibraryTotalPage <= 0"
                ></el-checkbox>
                <el-pagination
                  @current-change="goodsLibraryHandleCurrentChange"
                  :page-size="goodsLibraryPageSize"
                  :current-page="goodsLibraryPageNo"
                  background
                  layout="prev, pager, next, jumper"
                  :total="goodsLibraryTotalPage"
                ></el-pagination>
              </div>
            </div>
          </div>
          <div class="tab-footer">
            <span>已选服务：{{ goodsLibraryTotalCombinedNum }}</span>
            <el-button type="primary" @click="goodsLibrarySelGoodsConfrim"
              >确定</el-button
            >
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="previewImg" width="500px" append-to-body>
        <img width="100%" :src="previewImg" alt />
      </el-dialog>
      <el-dialog
        class="dialog-selproducts"
        width="600px"
        title="选择分类"
        :visible.sync="dialogCateSel"
        append-to-body
      >
        <div class="content-page">
          <div class="tab-content">
            <div class="products-list">
              <el-radio-group v-model="selCate" size="small">
                <el-radio
                  class="sel-cate-radio"
                  v-for="item in changeMenuList"
                  :label="item.goodsCategoryId"
                  :key="item.goodsCategoryId"
                  border
                  >{{ item.categoryName }}</el-radio
                >
              </el-radio-group>
              <div class="list-footer">
                <el-button type="primary" @click="selCateConfirm"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import {
  getFindAllGoods,
  getEdcShopGoodsCategorys,
  updateGoods,
  batchUpdateGoods,
  findGoodsNum,
  importGoodsNum,
  findGoodsSample,
  importSampleGoods,
} from "@/api";
import request from "@/utils/request";
import { getLodop } from "@/utils/LodopFuncs.js";
import { mapState } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";
let goodsListOptions = [];

let goodsLibraryGoodsListOptions = [];
let beforeChangeList = [];
export default {
  mixins: [commonFuc],
  data() {
    return {
      xlsLink: `${request.baseUrl}/download/导入服务模板.xls`,
      isShowSort: false,
      allChecked: false,
      isIndeterminate: false,
      isSel: false,
      tagsChange: "hot",
      tagsVisible: false,
      goodsList: [],
      checkedGoodsList: [],
      statusValue: "all",
      statusList: [
        {
          value: "all",
          label: "所有状态",
        },
        {
          value: "0",
          label: "已下架",
        },
        // {
        //   value: "-100",
        //   label: "已售罄",
        // },
      ],
      searchInput: "",
      menuList: [],
      changeMenuList: [],
      menuSel: "hot",
      totalPage: 0,
      pageSize: 10,
      pageNo: 1,
      isLoad: false,
      isShowSearch: false,
      defaultImg: require("../assets/img/common/default-img.jpg"),
      dialogGoodsSel: false,
      goodsLibrarySearchInput: "",
      goodsLibraryClassifyOptions: [
        {
          categoryName: "火锅",
        },
        {
          categoryName: "炒菜",
        },
        {
          categoryName: "时蔬",
        },
        {
          categoryName: "主食",
        },
        {
          categoryName: "饺子",
        },
        {
          categoryName: "烧烤",
        },
        {
          categoryName: "烤串",
        },
        {
          categoryName: "小吃",
        },
        {
          categoryName: "奶茶",
        },
        {
          categoryName: "盖浇饭",
        },
        {
          categoryName: "面",
        },
        {
          categoryName: "粥",
        },
      ],
      goodsLibraryCheckedGoodsList: [],
      goodsLibraryGoodsList: [],
      goodsLibraryIsIndeterminate: false,
      goodsLibraryAllChecked: false,
      goodsLibraryTotalPage: 0,
      goodsLibraryPageSize: 5,
      goodsLibraryPageNo: 1,
      goodsLibraryTotalCombinedNum: 0,
      goodsLibraryMenuSel: "火锅",
      dialogCateSel: false,
      selCate: "",
      previewImg: "",
    };
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
  },
  watch: {
    goodsLibraryCheckedGoodsList() {
      let count = 0;
      this.goodsLibraryCheckedGoodsList.forEach((val) => {
        count++;
      });
      this.goodsLibraryTotalCombinedNum = count;
    },
    statusValue(value) {
      console.log(value);
      this.checkAllChange(false);
      this.getNextData();
      if (value == "all") {
        this.isShowSearch = false;
      } else {
        this.isShowSearch = true;
      }
    },
    searchInput(val) {
      if (!val.length) {
        this.isShowSearch = false;
        this.getNextData();
      }
    },
    goodsLibrarySearchInput(val) {
      if (!val.length) {
        this.getGoodsLibraryNextData();
      }
    },
  },
  mounted() {
    this.$dragging.$on("dragged", ({ value }) => {});
    this.getPageData();
    this.pageNo = Number(this.$route.query.pageNo) || 1;
    this.menuSel = this.$route.query.menuSel || "hot";
  },
  methods: {
    getPageData() {
      this.getEdcShopGoodsCategorys();
    },
    getNextData() {
      this.getGoodsList();
      this.findGoodsNum();
    },
    getGoodsLibraryNextData() {
      findGoodsSample({
        goodsNatureType: 2,
        kw: this.goodsLibrarySearchInput
          ? this.goodsLibrarySearchInput
          : this.goodsLibraryMenuSel,
        pageNumber: this.goodsLibraryPageNo,
        pageSize: this.goodsLibraryPageSize,
      }).then((res) => {
        if (res.code == 1) {
          goodsLibraryGoodsListOptions = [];
          res.data.list.forEach((val) => {
            goodsLibraryGoodsListOptions.push(val.id);
          });
          this.goodsLibraryGoodsList = res.data.list;
          this.goodsLibraryTotalPage = res.data.totalCount;
          let checkedCount = res.data.list.filter((val) => {
            return this.goodsLibraryCheckedGoodsList.indexOf(val.id) > -1;
          }).length;
          this.goodsLibraryAllChecked =
            checkedCount === this.goodsLibraryGoodsList.length;
          this.goodsLibraryIsIndeterminate =
            checkedCount > 0 &&
            checkedCount < this.goodsLibraryGoodsList.length;
        }
      });
    },
    menuSelAction(id) {
      if (this.menuSel == id) {
        return;
      }
      this.menuSel = id;
      this.pageNo = 1;
      this.searchInput = "";
      this.statusValue = "all";
      this.checkAllChange(false);
      this.getNextData();
    },
    goodsLibraryMenuSelAction(name) {
      if (this.goodsLibraryMenuSel == name) {
        return;
      }
      this.goodsLibraryMenuSel = name;
      this.goodsLibraryPageNo = 1;
      this.goodsLibrarySearchInput = "";
      this.getGoodsLibraryNextData();
    },
    getGoodsList() {
      this.isLoad = true;
      getFindAllGoods({
        goodsNatureType: 2,
        saleStatus: this.statusValue != "all" ? Number(this.statusValue) : "",
        goodsCategoryId: this.menuSel == "hot" ? "" : this.menuSel,
        hotSale: this.menuSel == "hot" ? 1 : "",
        pageNo: this.pageNo,
        row: this.pageSize,
        goodsName: this.searchInput,
      }).then((res) => {
        if (res.code == 1) {
          goodsListOptions = [];
          res.data.forEach((val) => {
            val.visible = false;
            this.tagsChange = this.menuSel;
            val.tagsChange = this.menuSel;
            goodsListOptions.push(val.goodsId);
          });
          this.goodsList = res.data;
        }
        if (res.code == -1) {
          this.goodsList = [];
        }
        this.isLoad = false;
      });
    },
    findGoodsNum() {
      findGoodsNum({
        goodsNatureType: 2,
        saleStatus: this.statusValue != "all" ? Number(this.statusValue) : "",
        goodsCategoryId: this.menuSel == "hot" ? "" : this.menuSel,
        hotSale: this.menuSel == "hot" ? 1 : "",
        goodsName: this.searchInput,
      }).then((res) => {
        if (res.code == 1) {
          this.totalPage = res.data;
          if (this.pageNo > this.totalPage / this.pageSize) {
            this.pageNo = Math.ceil(this.totalPage / this.pageSize);
          }
        }
      });
    },
    editGoods(goodsId) {
      console.log(this.statusValue);
      this.$router.push({
        path: `/service/edit?goodsId=${goodsId}&pageNo=${this.pageNo}&menuSel=${
          this.menuSel
        }`,
      });
    },
    goodsDetail(goodsId) {
      this.$router.push({
        path: `/service/detail?goodsId=${goodsId}`,
      });
    },
    changeCategory(goodsId, goodsCategoryId, index = NaN) {
      if (index) {
        this.goodsList[index].visible = false;
      }
      let params = {
        goodIds: goodsId,
        bachMethod: "G",
        goodsCategoryId: goodsCategoryId,
      };
      this.batchUpdateGoods(params);
    },
    changeCategoryAll() {
      let goodIds = this.checkedGoodsList.join(",");
      this.tagsVisible = false;
      this.changeCategory(goodIds, this.tagsChange);
    },
    toggleSaleStatusAll(saleStatus) {
      let goodsIds = this.checkedGoodsList.join(",");
      this.toggleSaleStatus(saleStatus, goodsIds);
      this.checkAllChange(false);
    },
    toggleSaleStatus(saleStatus, goodsId) {
      let params = {
        goodIds: goodsId,
        bachMethod: "U",
        saleStatus: saleStatus ? 0 : 1,
      };
      this.batchUpdateGoods(params);
    },
    delGoods(goodsId) {
      let params = {
        goodsNatureType: 2,
        goodIds: goodsId,
        bachMethod: "D",
      };
      this.$msgbox({
        title: "消息",
        message: `是否删除，删除后将无法恢复！`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.batchUpdateGoods(params);
            done();
          } else {
            done();
          }
        },
      }).then((action) => {});
    },
    delGoodsAll() {
      let goodsIds = this.checkedGoodsList.join(",");
      this.delGoods(goodsIds);
    },
    batchUpdateGoods(params, cb) {
      batchUpdateGoods(params).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: params.bachMethod == "D" ? "删除成功" : "修改成功",
            type: "success",
            duration: 2000,
          });
          cb && cb();
          this.getNextData();
        } else {
          this.$notify({
            title: "警告",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    getEdcShopGoodsCategorys() {
      getEdcShopGoodsCategorys({
        categoryNatureType: 2,
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          this.changeMenuList = res.data
            .map((val) => {
              return val.categoryType != 2 && val;
            })
            .filter((val) => val);
          console.log(this.changeMenuList);
          this.menuList = JSON.parse(JSON.stringify(res.data));
          this.selCate = this.menuList[0].goodsCategoryId;
          this.menuList.unshift({
            categoryName: "热销",
            goodsCategoryId: "hot",
          });
          this.getNextData();
        }
      });
    },
    goodsShort() {
      this.pageNo = 1;
      this.pageSize = 1000;
      this.getGoodsList();
      this.isShowSort = true;
    },
    tabsChange(val) {
      console.log(val);
    },
    checkAllChange(val) {
      this.checkedGoodsList = val ? goodsListOptions : [];
      this.isIndeterminate = false;
      this.isSel = val;
      this.allChecked = val;
    },
    checkedGoodsChange(value) {
      let checkedCount = value.length;
      this.allChecked = checkedCount === this.goodsList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.goodsList.length;
      this.isSel = checkedCount > 0;
    },
    searchGoods() {
      this.pageNo = 1;
      this.checkAllChange(false);
      this.getNextData();
      if (this.searchInput.length) {
        this.isShowSearch = true;
      } else {
        if (this.statusValue == "all") {
          this.isShowSearch = false;
        }
      }
    },
    moveToTop(index) {
      let list = this.goodsList;
      list.unshift(...list.splice(index, 1));
    },
    moveToBottom(index) {
      let list = this.goodsList;
      list.push(...list.splice(index, 1));
    },
    saveSort() {
      let goodsList = JSON.parse(JSON.stringify(this.goodsList));
      goodsList.reverse();
      let params = {
        bachMethod: "I",
        goodsIndexNoJson: [],
      };
      goodsList.forEach((val, index) => {
        params.goodsIndexNoJson.push({
          goodsId: val.goodsId,
          indexNo: index,
        });
      });
      params.goodsIndexNoJson = JSON.stringify(params.goodsIndexNoJson);
      this.batchUpdateGoods(params, () => {
        this.pageSize = 5;
        this.isShowSort = false;
      });
    },
    cancelSort() {
      this.pageSize = 5;
      this.getNextData();
      this.isShowSort = false;
    },
    handleSizeChange(val) {
      console.log("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      console.log("handleCurrentChange", val);
      this.pageNo = val;
      this.checkAllChange(false);
      this.getNextData();
    },
    linkTo(path) {
      this.$router.push({
        path: path,
      });
    },
    uploadXls(item) {
      if (!~item.file.name.indexOf(".xls")) {
        this.$notify({
          title: "警告",
          message: "请上传xls格式文件",
          type: "warning",
          duration: 2000,
        });
        return;
      }
      let sessionId = localStorage.getItem("sessionId");
      let userId = localStorage.getItem("userId");
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("goodsNatureType", 2);
      imgUploadForm.append("userId", userId);
      imgUploadForm.append("sessionId", sessionId);
      importGoodsNum(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "导入成功",
            type: "success",
            duration: 2000,
          });
          this.getNextData();
        }
        if (res.code == 0) {
          this.$notify({
            title: "警告",
            message: res.msg,
            type: "warning",
            duration: 2000,
          });
        }
      });
    },
    downloadTemp() {},
    resetSearch() {
      this.isShowSearch = false;
      this.pageNo = 1;
      this.searchInput = "";
      this.statusValue = "all";
      this.checkAllChange(false);
      this.getNextData();
    },
    hideTagsVisible() {
      this.tagsVisible = false;
      this.goodsList.forEach((val) => {
        val.visible = false;
      });
    },
    showTagsVisible(index) {
      this.hideTagsVisible();
      this.goodsList[index].visible = true;
    },
    exportGoods() {
      location.href = `${
        request.baseUrl
      }/edcmanageapi/Goods_exportGoods?userId=${
        localStorage.userId
      }&sessionId=${localStorage.sessionId}`;
    },
    goodsLibrarySearchGoods() {
      this.goodsLibraryPageNo = 1;
      this.getGoodsLibraryNextData();
    },
    goodsLibraryHandleCurrentChange(val) {
      console.log("handleCurrentChange", val);
      this.goodsLibraryPageNo = val;
      this.getGoodsLibraryNextData();
    },
    goodsLibrarySelGoodsConfrim() {
      if (!this.goodsLibraryCheckedGoodsList.length) {
        this.$notify({
          title: "警告",
          message: "请选择服务",
          type: "warning",
          duration: 2000,
        });
        return;
      }
      this.dialogCateSel = true;
      // this.dialogGoodsSel = false;
    },
    goodsLibraryCheckedGoodsChange(value) {
      console.log(value);
      let checkedCount = 0;
      this.goodsLibraryGoodsList.forEach((val) => {
        if (value.indexOf(val.id) > -1) {
          checkedCount++;
        }
      });
      this.goodsLibraryAllChecked =
        checkedCount === this.goodsLibraryGoodsList.length;
      this.goodsLibraryIsIndeterminate =
        checkedCount > 0 && checkedCount < this.goodsLibraryGoodsList.length;
    },
    goodsLibraryCheckAllChange(val) {
      beforeChangeList = JSON.parse(
        JSON.stringify(this.goodsLibraryCheckedGoodsList)
      );
      let mergeAddGoodsList = goodsLibraryGoodsListOptions.filter((val) => {
        return beforeChangeList.indexOf(val) == -1;
      });
      let mergeReduceGoodsList = beforeChangeList.filter((val) => {
        return goodsLibraryGoodsListOptions.indexOf(val) == -1;
      });
      console.log(beforeChangeList, mergeAddGoodsList);
      this.goodsLibraryCheckedGoodsList = val
        ? [...beforeChangeList, ...mergeAddGoodsList]
        : mergeReduceGoodsList;
      this.goodsLibraryIsIndeterminate = false;
      this.goodsLibraryAllChecked = val;
      beforeChangeList = [];
    },
    selCateConfirm() {
      importSampleGoods({
        goodsNatureType: 2,
        goodsCategoryId: this.selCate,
        goodIds: this.goodsLibraryCheckedGoodsList.join(","),
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "添加成功",
            type: "success",
            duration: 2000,
          });
          this.getPageData();
          this.dialogGoodsSel = false;
          this.dialogCateSel = false;
        } else {
          this.$notify({
            title: "警告",
            message: res.message,
            type: "warning",
            duration: 2000,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  overflow: auto;
  .bd {
    height: 100%;
    &.sort {
      height: 100%;
      overflow-y: scroll;
      .tab-header {
        background: #fffcf5;
        border-bottom-color: #f2e7b8;
        .sort-tips {
          display: inline-block;
          font-size: 12px;
          color: #555;
          line-height: 17px;
          margin-left: 20px;
        }
      }
      .tab-content {
        .goods-list {
          width: 100%;
        }
      }
    }
  }
  .tab-header {
    .btn-group-one {
      .upload-xls {
        display: inline-block;
        margin: 0 15px;
      }
    }
    .btn-group-two {
      .el-checkbox {
        margin-right: 15px;
      }
    }
  }
  .tab-content {
    height: calc(100% - 67px);
    .goods-classify-list {
      width: 120px;
      min-width: 120px;
      height: 100%;
      background: #f8f8f8;
      font-size: 12px;
      overflow: auto;
      li {
        color: #666666;
        padding-left: 20px;
        padding: 15px 20px;
        line-height: 20px;
        border-bottom: 1px solid #eeeeee;
        cursor: pointer;
        width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &.active {
          background: #fff;
        }
      }
    }
  }
  .goods-list {
    width: calc(100% - 120px);
    min-width: calc(100% - 120px);
    padding: 0 20px;
    box-sizing: border-box;
    overflow: auto;
    .search-header {
      line-height: 30px;
      margin: 10px 0;
      font-size: 14px;
      color: #333;
      padding-left: 10px;
      .el-link {
        vertical-align: top;
        line-height: 30px;
        margin-left: 20px;
      }
    }
    &.screen {
      width: 100%;
    }
    .goods-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #eeeeee;
      box-sizing: border-box;
    }
    .goods-info {
      display: flex;
      .pic {
        position: relative;
        width: 50px;
        height: 50px;
        border-radius: 4px;
        &::before {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          text-align: center;
          line-height: 50px;
          font-size: 12px;
        }
        &.lower-shelf {
          &::before {
            content: "已下架";
          }
        }
        &.sell-out {
          &::before {
            content: "已售罄";
          }
        }
        &.will-sell-out {
          &::before {
            content: "将售罄";
          }
        }
      }
      .info {
        margin-left: 15px;
        .title {
          font-size: 14px;
          line-height: 28px;
          color: #666666;
          .tag-list {
            display: inline-block;
            & > span {
              background: #ee3030;
              color: #fff;
              font-size: 12px;
              border-radius: 3px;
              padding: 0 5px;
            }
          }
        }
        .price {
          font-size: 14px;
          line-height: 22px;
          color: #ee3030;
        }
      }
    }
    .table-action {
      & > span {
        margin: 0 10px;
      }
    }
    .list-none {
      text-align: center;
      font-size: 14px;
      color: #999999;
      padding-top: 200px;
      & > p {
        margin: 10px 0;
      }
    }
  }
}
.dialog-selgoods {
  .content-page {
    overflow: hidden;
    .bd {
      height: 100%;
      &.sort {
        height: 100%;
        overflow-y: scroll;
        .tab-header {
          background: #fffcf5;
          border-bottom-color: #f2e7b8;
          .sort-tips {
            display: inline-block;
            font-size: 12px;
            color: #555;
            line-height: 17px;
            margin-left: 20px;
          }
        }
        .tab-content {
          .goods-list {
            width: 100%;
          }
        }
      }
    }
    .tab-header {
      .btn-group-one {
        .upload-xls {
          display: inline-block;
          margin: 0 15px;
        }
      }
      .btn-group-two {
        .el-checkbox {
          margin-right: 15px;
        }
      }
    }
    .tab-content {
      padding: 0;
      height: 500px;
      .goods-classify-list {
        width: 120px;
        min-width: 120px;
        height: 100%;
        background: #f8f8f8;
        font-size: 12px;
        overflow: auto;
        li {
          color: #666666;
          padding-left: 20px;
          padding: 15px 20px;
          line-height: 20px;
          border-bottom: 1px solid #eeeeee;
          cursor: pointer;
          width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &.active {
            background: #fff;
          }
        }
      }
    }
    .tab-footer {
      text-align: center;
      margin: 10px 0;
      .el-button {
        margin-left: 10px;
      }
    }
    .el-pagination {
      padding: 10px;
    }
    .goods-list {
      width: calc(100% - 120px);
      min-width: calc(100% - 120px);
      box-sizing: border-box;
      padding: 0;
      .list-title {
        display: flex;
        padding: 0 20px 0 0;
        line-height: 40px;
        background: #f8f8f8;
        .title {
          box-sizing: border-box;
          padding-left: 10px;
          flex: 1;
          &:first-of-type {
            min-width: 400px;
            max-width: 400px;
            padding-left: 40px;
          }
        }
      }
      .el-checkbox-group {
        height: calc(100% - 120px);
        overflow: auto;
      }
      .search-header {
        line-height: 30px;
        margin: 10px 0;
        font-size: 14px;
        color: #333;
        padding-left: 10px;
        .el-link {
          vertical-align: top;
          line-height: 30px;
          margin-left: 20px;
        }
      }
      &.screen {
        width: 100%;
      }
      .goods-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px solid #eeeeee;
        box-sizing: border-box;
      }
      .goods-info {
        display: flex;
        .pic {
          position: relative;
          width: 50px;
          height: 50px;
          border-radius: 4px;
          &::before {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            text-align: center;
            line-height: 50px;
            font-size: 12px;
          }
          &.lower-shelf {
            &::before {
              content: "已下架";
            }
          }
          &.sell-out {
            &::before {
              content: "已售罄";
            }
          }
          &.will-sell-out {
            &::before {
              content: "将售罄";
            }
          }
        }
        .info {
          margin-left: 15px;
          .title {
            font-size: 14px;
            line-height: 28px;
            color: #666666;
            .tag-list {
              display: inline-block;
              & > span {
                background: #ee3030;
                color: #fff;
                font-size: 12px;
                border-radius: 3px;
                padding: 0 5px;
              }
            }
          }
          .price {
            font-size: 14px;
            line-height: 22px;
            color: #ee3030;
          }
        }
      }
      .table-action {
        & > span {
          margin: 0 10px;
        }
      }
      .list-none {
        text-align: center;
        font-size: 14px;
        color: #999999;
        padding-top: 200px;
        & > p {
          margin: 10px 0;
        }
      }
    }
    .list-footer {
      padding-left: 5px;
    }
  }
}
.dialog-selproducts {
  .products-list {
    .el-radio {
      &.sel-cate-radio {
        margin: 0 10px 10px 0;
      }
    }
    .list-footer {
      text-align: center;
    }
  }
}
</style>

<style lang="less">
.content-page {
  .goods-list {
    .el-table {
      .el-table__header {
        .cell {
          line-height: 26px;
        }
      }
      .el-checkbox__label {
        padding-left: 15px;
        vertical-align: middle;
      }
    }
  }
}
.tags-type {
  min-width: 136px !important;
  box-sizing: border-box;
  .changeTags {
    .el-radio-group {
      height: 200px;
      overflow: auto;
    }
  }
  .el-button--mini {
    padding: 7px 12px;
  }
  .el-radio {
    margin-bottom: 14px;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>
